<template>
    <div class="product-bar-in-topic">
        <v-card flat style="">
            <v-card-title class="mb-0 pb-0">
                <v-chip
                        :class="chipClass"
                        :style="'background-image:url('+backgroundImageSrc+') !important; background-size: 50% !important;\n'+
'    background-repeat: no-repeat !important;\n'+
'    background-position: center center !important;transform-origin: bottom center; transform:scale('+(0.5+0.5*opacity)+');'"
                        outline
                        color="#CCD5ED"
                        text-color="primary">
                    <div style="width:100%;height:200px;position:absolute;cursor:pointer;" @click="showInfo=true">
                        <v-avatar class="product-icon">
                            <v-icon v-if="checked" style="color:#97D700;opacity:1;transform:scale(3);transform-origin:right;">new_releases</v-icon>
                            <v-icon v-if="!checked&&whyNot=='alreadySecured'" style="filter: grayscale(1);opacity:0.25;transform:scale(3);transform-origin:right;">check</v-icon>
                            <v-icon v-if="!checked&&whyNot=='notInterested'" style="filter: grayscale(1);opacity:0.25;transform:scale(3);transform-origin:right;">snooze</v-icon>
                        </v-avatar>
                        <!--img class="product-icon" :src="productIconSrc" :style="'opacity:'+opacity"-->
                    </div>
                </v-chip>
            </v-card-title>
            <v-card-text class="mt-0 pt-0" >
                <v-switch
                        ref="decisionSwitch"
                        v-model="checked"
                        label=""
                        color="primary"
                        style="right:0em;"
                ></v-switch>

                <!--v-avatar class="selection-button" @click="toggleChecked">
                    <v-icon class="mr-0" color="primary" v-if="checked!='yes'">add_circle</v-icon>
                    <v-icon class="mr-0" color="primary" v-else>remove_circle</v-icon>
                </v-avatar-->
            </v-card-text>
            <p class="product-label" style="cursor:pointer;" @click="showInfo=true">
                <span style="max-width:1em;display:inline-block;margin-right:0.5em;">
                    <v-icon class="mr-2" color="primary" small>info</v-icon>
                </span> <span v-html="product.label"></span> </p>
            <v-progress-linear height="5" class="progress-bar elevation-0 mr-1" :value="Math.min(100,Math.round(product.points*1.6666667))" color="rgb(151, 215, 0)"></v-progress-linear>
        </v-card>

        <v-dialog
                v-model="showInfo"
                width="500px"
                max-width="90%"
        >
            <v-card>
                <v-toolbar dark color="#002EA7">
                    <v-toolbar-title>Info</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon color="white" @click="showInfo = false;">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-title class="headline">{{ product.label }}</v-card-title>
                <v-card-text v-html="product.info">
                </v-card-text>
                <v-card-text>
                    <v-progress-linear height="5" class="progress-bar elevation-0 mr-1" :value="Math.min(100,Math.round(product.points*1.6666667))" color="rgb(151, 215, 0)"></v-progress-linear>
                </v-card-text>

            </v-card>
        </v-dialog>

        <v-dialog
                v-model="askWhy"
                width="500px"
                max-width="90%"
        >
            <v-card>
                <v-toolbar dark color="#002EA7">
                    <v-toolbar-title>Frage</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon color="white" @click="askWhy = false; checked = true;">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-title class="headline text-xs-left">Warum kommt die {{ product.label }} für Dich hier nicht in Frage?</v-card-title>
                <v-card-text>
                    <v-radio-group  row v-model="whyNot" @click="askWhy=false" :mandatory="false">
                        <v-radio label="Hab ich schon" value="alreadySecured"></v-radio>
                        <v-radio label="Interessiert mich nicht" value="notInterested"></v-radio>
                    </v-radio-group>
                </v-card-text>


            </v-card>
        </v-dialog>

    </div>
</template>

<script>
    export default {
        name: "ProductBarInTopic",
        props: ['product'],
        data(){
            return {
                showInfo: false,
                askWhy: false,
                whyNot: '',
                checked: true
            }
        },
        watch: {
            checked: function(){
                this.$store.commit('qa/SET_PRODUCT_CHECKED',{col: this.product.col, state: this.checked});
                this.askWhy = !this.checked;
                if(this.checked){
                    this.whyNot = '';
                }
            },
            whyNot: function(){
                this.askWhy = !this.checked;
                this.$store.commit('qa/SET_PRODUCT_DECISION',{col: this.product.col, decision: this.whyNot});
            },
            askWhy: function(val){
                if(val){
                    this.whyNot = '';
                }
            }
        },
        computed: {
            opacity(){
                return ( Math.min(100,Math.round(this.product.points*1.6666667)) / 100);
            },
            backgroundImageSrc(){
                return '/icons/products/'+this.product.icon+'.svg';
            },
            chipClass(){
                let c = 'product-chip buv elevation-1';
                if(this.checked==false) {
                    c += " deselected-chip "; //
                }
                return c;
            },
            productIconSrc(){
                return '/icons/products/'+this.product.icon+'.svg';
            }
        },
        methods: {
        }
    }
</script>

<style>
    /*
        background-image: url('/icons/cloud/Building-Construction Houses house-modern.svg') !important; */
    .product-chip.buv {
        background-size: 75% !important;
        background-repeat: no-repeat !important;
        background-position: center !important;
        width: 200px !important;
        height: 200px !important;
        border-radius: 50% !important;
        background-repeat: no-repeat !important;
        background-position: center top !important;
    }

    .NEINproduct-chip.buv:after {
        content : "";
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        background-image: url('/icons/cloud/Building-Construction Houses house-modern.svg');
        width: 100%;
        height: 100%;
        opacity : 0.2;
        z-index: -1;
    }

    .deselected-chip {
        opacity: 0.25;
    }

    div.product-bar {
    }
    .product-label {
        font-size: 0.5em !important;
        color: #002ea7;
        padding-left: 16px;
        overflow-wrap: break-word;
        width: 175px;
    }
    .product-label span i {
        display: inline-flex;
    }
    div.progress-bar {
        margin-left: 27px;
        margin-right: 27px;
        margin-top: 0;
        margin-bottom: 0;
        border-radius: 5px;
        margin-left: 16px;
    }
    .v-dialog .progress-bar {
        height: 5px;
        width: 100%;
        margin-left: 0;
    }
    span.v-chip {
        border-radius: 20px;
    }
    span.v-chip i, .v-chip__close > .v-icon {
        font-size: 32px !important;
        margin-left: 10px;
    }
    div.v-chip__close {
        position: absolute;
        right: 3px;
    }
    img.product-icon {
        width: 5em;
        margin-right: 0.5em;
        margin-left: 0.5em;
    }
    h3.product-label {
        font-size: 28px;
    }
    .v-avatar.product-icon {
        position: absolute;
        top: 0;
        right: 0;
    }
    .v-avatar.selection-button {
        position: absolute;
        right: 10px;
    }
    .v-avatar.product-info-button {
        position: absolute;
        width: 100%;

    }
    .v-avatar.product-info-button i {
        position: absolute;
        width: auto;
        right: 0;
    }
    .v-dialog .v-card__text {
        font-size: 18px;
        text-align: left;
    }
    .v-dialog .v-btn--icon{
        width: 28px;
        height: 28px;
    }
</style>
